export const VISITOR_LOG_EVENT_TYPES = {
  ENTRANCE: 'visitor_entrance',
  EXIT: 'visitor_exit',
};

export const VISITOR_LOG_VIEW_MODES = {
  VISITS: 'visits',
  EVENTS: 'events',
};

export const VISITOR_LOG_VISIT_STATUSES = {
  INSIDE: 'inside',
  EXITED: 'exited',
};

export const getVisitStatus = ({ dateExited }) =>
  dateExited == null ? VISITOR_LOG_VISIT_STATUSES.INSIDE : VISITOR_LOG_VISIT_STATUSES.EXITED;

export const getVisitStatusEventType = (visit) =>
  getVisitStatus(visit) === VISITOR_LOG_VISIT_STATUSES.INSIDE
    ? VISITOR_LOG_EVENT_TYPES.ENTRANCE
    : VISITOR_LOG_EVENT_TYPES.EXIT;

export const VISITOR_LOG_VISIT_FIELDS = {
  VISITEE: 'visitee',
  VISIT_PURPOSE: 'visit_purpose',
  VISIT_LOCATION: 'visit_location',
  COMMENTS: 'comments',
  PHOTOS: 'photos',
  CAR_PLATE: 'car_plate_number',
  CAR_MAKE: 'car_make',
  CAR_MODEL: 'car_model',
  CAR_COLOR: 'car_color',
};

export const VISIT_LOCATION_OPTIONS = {
  TEXT_ONLY: 'text',
  LOCATION_MAP: 'location_map',
};
